/** Browser-side half of the dev-only validated level-save contract. */

import { validateLevel, type LevelDef } from '@/levels/schema';

export interface LevelSaveResult {
  wrote: string;
}

export async function saveLevelDraft(
  fileName: string,
  level: LevelDef,
  fetcher: typeof fetch = fetch,
): Promise<LevelSaveResult> {
  const errors = validateLevel(level);
  if (errors.length > 0) throw new Error(`Level failed validation: ${errors.join('; ')}`);

  const response = await fetcher('/__save-level', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ fileName, level }),
  });

  const payload = (await response.json().catch(() => null)) as {
    wrote?: unknown;
    error?: unknown;
    errors?: unknown;
  } | null;
  if (!response.ok) {
    const detail = Array.isArray(payload?.errors) ? payload.errors.join('; ') : payload?.error;
    throw new Error(typeof detail === 'string' ? detail : `Save failed (${response.status})`);
  }
  if (typeof payload?.wrote !== 'string') throw new Error('Save endpoint returned no filename');
  return { wrote: payload.wrote };
}
